import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=0a5de464&scoped=true"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=0a5de464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5de464",
  null
  
)

export default component.exports